import React from 'react'
import Group from 'components/utils/Group'
import MerchandiseCartReviewTileContent from './MerchandiseCartReviewTileContent'

interface Props {
  brand: string;
  title: string;
  variant: App.MerchandiseOfferVariant;
}

function MerchandiseCartReviewCondensedTileContent(props: Props) {
  const {
    brand,
    title,
    variant,
  } = props

  return <Group
    direction="horizontal"
    horizontalAlign="start"
    fullWidth
    verticalAlign="start"
    gap={12}
  >
    <MerchandiseCartReviewTileContent
      brand={brand}
      title={title}
      variant={variant}
    />
  </Group>
}

export default React.memo(MerchandiseCartReviewCondensedTileContent)
